import enLocale from "element-ui/lib/locale/lang/en"; //引入element-ui中的英文内容


const localEnLocale = {
    ...enLocale,
    title : " OK " ,
    today: "today",
    userQuestion : " User consultation " ,
    transform : " Transfer to manual " ,
    message : " Message " ,
    camera : " Photo " ,
    file : " File " ,
    evaluate : " Evaluation " ,
    eval_title : " Satisfaction evaluation " ,
    eval_desc : " Have you solved the problem? " ,
    eval_submit : " Submit a review " ,
    msg_title : " Fill in a message " ,
    msg_submit : " Submit a message " ,
    msg_desc : " If you need help, please leave a message and we will contact and resolve it as soon as possible Your question " ,
    sendBtn : " Send " ,
    tips : " Prompt " ,
    sure : " OK " ,
    cancel : " Cancel " ,
    closeTips : " This operation will disconnect the current chat , do you want to continue ?" ,
    customerInputIng : " Customer service is working Input ..." ,
    historyChat : "The above is the history chat " ,
    loading : " Loading ..." ,
    noHistory : " No more records " ,
    download : " Download " ,
    input : " Please input " ,
    select: "Please select",
    orderStatus : " Order Status " ,
    orderNumber : " Order Number " ,
    showDetail : " View Details " ,
    orderTime : " Order Time " ,
    thump : " Like " ,
    top : " Like " ,
    submit : " Submit " ,
    pleInput : " Please Fill in" ,
    DIVInput : " Please Fill in" ,
    content : " Content! " ,
    rightPhone : " Please fill in the correct mobile phone number! " ,
    rightEmail : " Please fill in the correct email address! " ,
    emoji : " Expression " ,
    leaveMsg : " Message " ,
    uploadFile : " Upload file " ,
    reChat : " Re-conversation " ,
    chatAfterEva : "Service evaluation may be completed after inquiry " ,
    veryGood : " Very satisfied, five-star praise " ,
    notGood : " Not very satisfied, need to be improved " ,
    userName : " Contact name " ,
    userPhone : " Contact phone number " ,
    userEmail : " Email address " ,
    leaveMsgCon : " Message content " ,
    submitLeave : " Submit message " ,
    noSubmitEvaEndChat: "Don't evaluate the ending session temporarily",
    getHistory : " Get history " ,
    isResolved : " Did it help you solve the problem? " ,
    leaveTip : " Little Master, I haven't done enough, I still need to study hard " ,
    leaveInput : " Welcome to give us your opinion " ,
    solved : " Solved " ,
    noSolved : " Unsolved " ,
    submitEva : " Submit Evaluation " ,
    evaConInput : " Please fill in the evaluation content! " ,
    evaLabelSelect : " Please select an evaluation label! " ,
    robotEva1 : " Unanswered questions " ,
    robotEva2 : " Poor understanding " ,
    robotEva3 : " Can't answer questions " ,
    robotEva4 : " Irrespective " ,
    customerEva1 : " Poor service attitude " ,
    customerEva2 : " Untimely answer " ,
    customerEva3 : " Didn't solve the problem " ,
    customerEva4 : " I'm not polite " ,
    leaveMessage : " The following is an offline message " ,
    helloMsg : " Hello, what can I do to help you " ,
    noCustomer : " No customer service online at the moment " ,
    isSureLeave : " OK to leave the current page ? " ,
    customer : " customer service " ,
    customerFirst: "Welcome to V9Bet! One moment — we're connecting you to ",
    connectChat : " established a session with you " ,
    busyMessage : " customer service has been busy turning over " ,
    transferFailed : " transfer to manual failed! " ,
    notWork : " Customer service is off work! " ,
    closeChat : " The chat between customer service and you has ended! " ,
    newWindow : " Your session opens in a new window! " ,
    chatOver : " The chat with you has ended! " ,
    backMessage : " Customer service retracted a message! " ,
    thankMessage : " Thank you for your review! " ,
    fileMax : "The file cannot be larger than 50M ! " ,
    newMessage : " [You have received a new message] " ,
    inputUserName : " Please enter your contact name !" ,
    inputUserPhone : " Please fill in the correct mobile phone number !" ,
    inputUserEmail : " Please fill in the correct email address !" ,
    inputLeaveMsg : " Please enter the message content !" ,
    submitSuc : " Submit successfully !" ,
    fileTypeError : "Invalid file format" ,
    onlyIMG:'Wrong file type, only pictures or movies can be sent!',
    attachments:'attachments',
    createTime: 'Create Time',
    updateTime: 'Update time',
    woStatus: "Message status",
    orderNoYet: ' Not yet accepted ',
    orderAccept: ' Accepting ',
    orderWait: ' Waiting for reply ',
    orderResolved: ' resolved ',
    orderOver: ' closed ',
    orderPriority: ' Priority ',
    orderDanger: ' urgent ',
    orderWarning: ' high ',
    orderNormal: ' Medium ',
    orderLow: ' low ',
    reply:'reply',
    client:'client',
    leaveHis: "Record",
    txbj: 'Hello, we are sorry that we are unable to provide services for you temporarily. If you need help, please leave a message, and we will contact you and solve your problem as soon as possible',
    messageName:'Customer Name',
    messageEmail:'Customer Email',
    messagePhone:'Customer Phone',
    messageContent:'Message content',
    messageSubmitTime:'Submission time',
    messageStatus:'Message status',
    messageDealTime:'Processing time',
    haveDeal:'Processed',
    noDeal:'untreated',
}

export default localEnLocale;




// WEBPACK FOOTER //
// ./src/language/en.js